import { createContext, useContext } from 'react';

export interface MemoDetailsContextValue {
  isEditMemoTrowserOpen: boolean;
  openEditMemoTrowser: () => void;
}

export const MemoDetailsContext = createContext<MemoDetailsContextValue | null>(
  null
);

export function useUnguardedMemoDetails() {
  return useContext(MemoDetailsContext);
}
